const OpenSettingsSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" fill="none">
            <rect width="32" height="42" fill="#D4E2F4" rx="5"/>
            <path fill="#546EDB" d="M16 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0-7a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>
        </svg>
    )
}

export default OpenSettingsSvg;